import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ProjectArrayModel,
  ProjectModel,
  AdminProjectModel,
} from "../../models/ProjectModel";

const initialProjectState: ProjectArrayModel = {
  all_Projects: [],
  particular_Project: {
    projectId: 0,
    projectName: "",
    userId: 0,
    csgoid: 0,
    sbgid: 0,
    sbuid: 0,
    buid: 0,
    segmentLobid: 0,
    segmentClassification: "",
    customerGreenClassification: true,
    isBaseLoad: true,
    isGreenListCustomer: true,
    assessCustomerRating: "",
    briefScope: "",
    estimatedValue: 0,
    valueSlab: "",
    isNewProcessApplicable: undefined,
    preBidExpenses: 0,
    isPriceVariation: "",
    isPqrequired: "",
    preQualificationRequirement: "",
    isJvpartnerRequired: true,
    jvpartnerSuggestedName: "",
    isTechPartnerRequired: true,
    techPartnerSuggestedName: "",
    winProbabilityPercentage: 0,
    tenderExpectedDate: new Date(),
    awardExpectedDate: new Date(),
    projectDuration: 0,
    isOM: true,
    omduration: 0,
    estimatedTimeToBid: 0,
    environmentClearanceStatus: "",
    country: "",
    state: "",
    city: "",
    location: "",
    isLicenseRequired: true,
    licenseProcurementNextSteps: "",
    rowstatus: "",
    tenderMaturity: "",
    expectedCompetitors: "",
    additionalInformation: "",
    createdDate: new Date(),
    modifiedBy: "string",
    modifiedDate: new Date(),
    contractTypeId: 0,
    customerNameId: 0,
    geographyId: 0,
    competitionIntensityId: 0,
    proposalStage: "",
    competitorsWithClient: "",
    winStrategyAndValueProposition: "",
    timeToPQDays: 0,
    countryCorruptionRating: "",
    tenderingBandwidthId: 0,
    fundingSourceId: 0,
    isActive: true,
    goFactorPercentage: 0,
    getFactorPercentage: 0,
    manualGoFactorPercentage: 0,
    manualGetFactorPercentage: 0,
    manualGoGetFactorPercentage: 0,
    manualGoGetFactorRemarks: "",
    bidManagerName: "",
    isNewTeprocessCommenced: undefined,
    isWorkStarted: undefined,
    bidExploratoryStatus: false,
    bidSubmissionDate: new Date(),
    opportunityQualification: "",
    isBidDropped: false,
    priority: "",
    enforceCsgoApproval: false
  },
  project_Object: {
    projectId: 0,
    projectName: "",
    userId: 0,
    csgoid: 0,
    sbgid: 0,
    sbuid: 0,
    buid: 0,
    segmentLobid: 0,
    segmentClassification: "",
    customerGreenClassification: true,
    isBaseLoad: true,
    isGreenListCustomer: true,
    assessCustomerRating: "",
    briefScope: "",
    estimatedValue: 0,
    valueSlab: "",
    isNewProcessApplicable: undefined,
    preBidExpenses: 0,
    isPriceVariation: "",
    isPqrequired: "",
    preQualificationRequirement: "",
    isJvpartnerRequired: true,
    jvpartnerSuggestedName: "",
    isTechPartnerRequired: true,
    techPartnerSuggestedName: "",
    winProbabilityPercentage: 0,
    tenderExpectedDate: new Date(),
    awardExpectedDate: new Date(),
    projectDuration: 0,
    isOM: true,
    omduration: 0,
    estimatedTimeToBid: 0,
    environmentClearanceStatus: "",
    country: "",
    state: "",
    city: "",
    location: "",
    isLicenseRequired: true,
    licenseProcurementNextSteps: "",
    rowstatus: "",
    tenderMaturity: "",
    expectedCompetitors: "",
    additionalInformation: "",
    createdDate: new Date(),
    modifiedBy: "",
    modifiedDate: new Date(),
    contractTypeId: 0,
    customerNameId: 0,
    geographyId: 0,
    competitionIntensityId: 0,
    proposalStage: "",
    competitorsWithClient: "",
    winStrategyAndValueProposition: "",
    timeToPQDays: 0,
    countryCorruptionRating: "",
    tenderingBandwidthId: 0,
    fundingSourceId: 0,
    isActive: true,
    goFactorPercentage: 0,
    getFactorPercentage: 0,
    manualGoFactorPercentage: 0,
    manualGetFactorPercentage: 0,
    manualGoGetFactorPercentage: 0,
    manualGoGetFactorRemarks: "",
    bidManagerName: "",
    isNewTeprocessCommenced: undefined,
    isWorkStarted: undefined,
    bidExploratoryStatus: false,
    bidSubmissionDate: new Date(),
    opportunityQualification: "",
    isBidDropped: false,
    priority: "",
    enforceCsgoApproval: false
  },
  projectNameExists: false,
  allAdminProjects: [],
  isAdminProjectsFetching: false,
};
const ProjectSlice = createSlice({
  name: "Project",
  initialState: initialProjectState,
  reducers: {
    setProjects(state, action: PayloadAction<ProjectModel[]>) {
      state.all_Projects = action.payload;
    },
    setParticularProject(state, action: PayloadAction<ProjectModel>) {
      state.particular_Project = action.payload;
    },
    setIfProjectNameExists(state, action: PayloadAction<boolean>) {
      state.projectNameExists = action.payload;
    },
    //Basic Info Slices
    setProjectId: (state, action: PayloadAction<number>) => {
      state.project_Object.projectId = action.payload;
    },
    setUserId: (state, action: PayloadAction<number>) => {
      state.project_Object.userId = action.payload;
    },
    setProjectName: (state, action: PayloadAction<string>) => {
      state.project_Object.projectName = action.payload;
    },
    setCSGO: (state, action: PayloadAction<number>) => {
      state.project_Object.csgoid = action.payload;
    },
    setSBG: (state, action: PayloadAction<number>) => {
      state.project_Object.sbgid = action.payload;
    },
    setSBU: (state, action: PayloadAction<number>) => {
      state.project_Object.sbuid = action.payload;
    },
    setBUID: (state, action: PayloadAction<number>) => {
      state.project_Object.buid = action.payload;
    },
    setSegmentLOBID: (state, action: PayloadAction<number>) => {
      state.project_Object.segmentLobid = action.payload;
    },
    setCustomerName: (state, action: PayloadAction<number>) => {
      state.project_Object.customerNameId = action.payload;
    },
    setSegmentClassification: (state, action: PayloadAction<string>) => {
      state.project_Object.segmentClassification = action.payload;
    },
    setBaseLoad: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isBaseLoad = action.payload;
    },
    setIsGreenCustomer: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isGreenListCustomer = action.payload;
    },
    // setCustomerTypeId: (state, action: PayloadAction<number | string>) => {
    //     state.project_Object.customerTypeId = action.payload;
    // },
    setBriefScope: (state, action: PayloadAction<string>) => {
      state.project_Object.briefScope = action.payload;
    },
    setEstimatedValue: (state, action: PayloadAction<number | string>) => {
      state.project_Object.estimatedValue = action.payload;
    },
    setContractType: (state, action: PayloadAction<number>) => {
      state.project_Object.contractTypeId = action.payload;
    },
    setPriceVariance: (state, action: PayloadAction<string>) => {
      state.project_Object.isPriceVariation = action.payload;
    },
    setAssessCustomerRating: (state, action: PayloadAction<string>) => {
      state.project_Object.assessCustomerRating = action.payload;
    },

    //Bid Details
    setPreQualification: (state, action: PayloadAction<string>) => {
      state.project_Object.isPqrequired = action.payload;
    },
    setPreQualificationRating: (state, action: PayloadAction<string>) => {
      state.project_Object.preQualificationRequirement = action.payload;
    },
    setJVPartenerReq: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isJvpartnerRequired = action.payload;
    },
    setJVPartnerSuggestedName: (state, action: PayloadAction<string>) => {
      state.project_Object.jvpartnerSuggestedName = action.payload;
    },
    setTechParterReq: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isTechPartnerRequired = action.payload;
    },
    setTechPartnerSuggestedName: (state, action: PayloadAction<string>) => {
      state.project_Object.techPartnerSuggestedName = action.payload;
    },
    setWinProbability: (state, action: PayloadAction<number>) => {
      state.project_Object.winProbabilityPercentage = action.payload;
    },
    setFundingSource: (state, action: PayloadAction<number>) => {
      state.project_Object.fundingSourceId = action.payload;
    },
    setTenderExpectedDate: (state, action: PayloadAction<Date>) => {
      state.project_Object.tenderExpectedDate = action.payload;
    },
    setAwardExpectedDate: (state, action: PayloadAction<Date>) => {
      state.project_Object.awardExpectedDate = action.payload;
    },
    setProjectDuration: (state, action: PayloadAction<number>) => {
      state.project_Object.projectDuration = action.payload;
    },
    setEstimatedTimeToBid: (state, action: PayloadAction<number>) => {
      state.project_Object.estimatedTimeToBid = action.payload;
    },
    setOAndM: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isOM = action.payload;
    },
    setOMDuration: (state, action: PayloadAction<number>) => {
      state.project_Object.omduration = action.payload;
    },
    setTenderingBandwidth: (state, action: PayloadAction<number>) => {
      state.project_Object.tenderingBandwidthId = action.payload;
    },

    // Other Details
    setTenderMaturity: (state, action: PayloadAction<string>) => {
      state.project_Object.tenderMaturity = action.payload;
    },
    setCountry: (state, action: PayloadAction<string>) => {
      state.project_Object.country = action.payload;
    },
    setState: (state, action: PayloadAction<string>) => {
      state.project_Object.state = action.payload;
    },
    setCity: (state, action: PayloadAction<string>) => {
      state.project_Object.city = action.payload;
    },
    setLocation: (state, action: PayloadAction<string>) => {
      state.project_Object.location = action.payload;
    },
    setEnvironmentClearanceStatus: (state, action: PayloadAction<string>) => {
      state.project_Object.environmentClearanceStatus = action.payload;
    },
    setRowStatus: (state, action: PayloadAction<string>) => {
      state.project_Object.rowstatus = action.payload;
    },
    setGeography: (state, action: PayloadAction<number>) => {
      state.project_Object.geographyId = action.payload;
    },
    setCompetitionIntensity: (state, action: PayloadAction<number>) => {
      state.project_Object.competitionIntensityId = action.payload;
    },
    setProposalStage: (state, action: PayloadAction<string>) => {
      state.project_Object.proposalStage = action.payload;
    },
    setCompetitorsWithClient: (state, action: PayloadAction<string>) => {
      state.project_Object.competitorsWithClient = action.payload;
    },
    setWinStrategyAndValueProposition: (
      state,
      action: PayloadAction<string>
    ) => {
      state.project_Object.winStrategyAndValueProposition = action.payload;
    },
    setTimeToPQ: (state, action: PayloadAction<number>) => {
      state.project_Object.timeToPQDays = action.payload;
    },
    setLicenseRequired: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isLicenseRequired = action.payload;
    },
    setLicenseRequiredNotAvailable: (state, action: PayloadAction<string>) => {
      state.project_Object.licenseProcurementNextSteps = action.payload;
    },
    setExpectedCompetitors: (state, action: PayloadAction<string>) => {
      state.project_Object.expectedCompetitors = action.payload;
    },
    setAnyOtherAdditionalInfo: (state, action: PayloadAction<string>) => {
      state.project_Object.additionalInformation = action.payload;
    },
    setProjectObjectWithInitialValues: (state) => {
      state.project_Object = initialProjectState.project_Object;
    },
    setProjectObjectWithEditProject: (state, action: PayloadAction<object>) => {
      state.project_Object = {
        ...state.project_Object,
        ...action.payload,
      };
    },
    setOthersContactType: (state, action: PayloadAction<string>) => {
      state.project_Object.otherContractType = action.payload;
    },
    setCountryCorruptionRating: (state, action: PayloadAction<string>) => {
      state.project_Object.countryCorruptionRating = action.payload;
    },
    setOthersFundingSource: (state, action: PayloadAction<string>) => {
      state.project_Object.otherFundingSource = action.payload;
    },
    setGoFactorPercentage: (state, action: PayloadAction<number>) => {
      state.project_Object.goFactorPercentage = action.payload;
    },
    setGetFactorPercentage: (state, action: PayloadAction<number>) => {
      state.project_Object.getFactorPercentage = action.payload;
    },
    setManualGoFactorPercentage: (state, action: PayloadAction<number>) => {
      state.project_Object.manualGoFactorPercentage = action.payload;
    },
    setManualGetFactorPercentage: (state, action: PayloadAction<number>) => {
      state.project_Object.manualGetFactorPercentage = action.payload;
    },
    setManualGoGetFactorPercentage: (state, action: PayloadAction<number>) => {
      state.project_Object.manualGoGetFactorPercentage = action.payload;
    },
    setManualGoGetFactorRemarks: (state, action: PayloadAction<string>) => {
      state.project_Object.manualGoGetFactorRemarks = action.payload;
    },
    setAdminProjects(state, action: PayloadAction<AdminProjectModel[]>) {
      state.allAdminProjects = action.payload;
    },
    setValueSlab: (state, action: PayloadAction<string>) => {
      state.project_Object.valueSlab = action.payload;
    },
    setIsNewProcessApplicable: (state, action: PayloadAction<boolean>) => {
      state.project_Object.isNewProcessApplicable = action.payload;
    },
    setPreBidExpenses: (state, action: PayloadAction<number | string>) => {
      state.project_Object.preBidExpenses = action.payload;
    },
    setIsAdminProjectsFetching(state, action: PayloadAction<boolean>) {
      state.isAdminProjectsFetching = action.payload;
    },
    setBidSubmissionDate: (state, action: PayloadAction<Date>) => {
      state.project_Object.bidSubmissionDate = action.payload;
    },
    setOpportunityQualification: (state, action: PayloadAction<string>) => {
      state.project_Object.opportunityQualification = action.payload;
    },
  },
});
export default ProjectSlice;
